import { useContext } from "react";
import './app-list.scss';
import { LocationsContext } from "../map-artworks/map-artworks";
import type { MapLocation } from "../../interfaces/MapLocation";

export function AppList({list}:any){

    const locationObject = useContext<any>(LocationsContext)
    
    function handleClick(location:MapLocation){
       locationObject.setSelectedLocation(location);
    }
    return(
        <ul>
            {list.map((listItem:any)=>{
                const {name,map_cover_image,id} = listItem.location

               return  <li key={id} className="app-list-item" onClick={()=>handleClick(listItem.location)}>
                            <img className="img-rounded" src={`/api/assets/${map_cover_image.id}?key=icon-thumbnail`} alt={name} title={name}/> {name}
                        </li>
            })}
        </ul>
    )
}